export const ATTACHMENT_UPLOAD_CHANNEL = 'attachmentUpload';
export const ATTACHMENT_UPLOAD_STATUS_CHANGE_EVENT = 'statusChange';
export const ATTACHMENT_UPLOAD_STATUS_REMOVE_EVENT = 'statusRemove';
